<section
  class="category-group"
  [class.category-group--collapsed]="collapsed()"
  [class.category-group--readonly]="readOnly()"
  [class.category-group--unavailable]="!isCategoryAvailable()"
  [class.category-group--sticky-header]="stickyHeader()"
>
  @if (displayHeader()) {
    @if (readOnly()) {
      <div class="category-group__header category-group__header--flat">
        <span class="category-group__title">
          {{ headerLabel() }} <span class="category-group__count">( {{ productCount() }} )</span>
        </span>
      </div>
    } @else {
      <button
        type="button"
        class="category-group__header"
        (click)="toggle()"
        [attr.aria-expanded]="!collapsed()"
      >
        <span class="category-group__title">
          {{ headerLabel() }} <span class="category-group__count">( {{ productCount() }} )</span>
        </span>
        <pxw-icon class="category-group__chevron" icon="chevron-down" size="sm" />
      </button>
    }
  }

  @if (readOnly() || !collapsed()) {
    <div class="category-group__body">
      @if (!isCategoryAvailable()) {
        <pxw-alert class="category-group__not-available" type="warning" size="sm">
          <pxw-icon icon="clock" />
          <div class="category-group__not-available-content">
            {{ unavailableAlertText() }}
            <pxw-button color="yellow" size="sm" [rounded]="true" (click)="openAvailability.emit()">
              {{ checkScheduleLabel() }}
            </pxw-button>
          </div>
        </pxw-alert>
      }
      <div class="category-group__products">
        <ng-content />
      </div>
    </div>
  }
</section>
